export function setBenefits(state, benefits) {
  state.benefits = benefits; 
}

export function setBenefit(state, benefit) {
  state.selectedBenefit = benefit;
}

export function setBenefitTypes(state, benefit) {
  state.selectedBenefit = benefit;
}

export function benefitsError(state, payload) {
  state.error = true
  state.errorMessage = payload
  state.benefits = []
}

export function setBenefitTypeScroll(state, payload) {
  state.benefitTypeScroll = payload
}